import Image from '../../../Image';
// Component Commons
import SelectSport from '../../sections/SelectSport';
import NavbarInside from '../../layout/NavbarInside';
// assets
import CoverImg from '../../images/fondo.png';

export default function Sports(): JSX.Element {
    return (
        <section className="relative snap-center" role="sports">
            <h1 className="hidden relative text-2xl">Supermatch</h1>
            <NavbarInside />
            <SelectSport />
            <Image className="z-0" src={CoverImg} alt="Fondo" layout="fill" objectFit="cover" objectPosition="center" />
        </section>
    );
}
